import { CSSProperties } from "react";

import { useTheme } from "@hooks";
import { spacing } from "@layout";

export const useStyles = () => {
  const { theme } = useTheme();

  const styles: Record<string, CSSProperties> = {
    // One gap for the whole block, everything on the same left edge. Replaces the per-element
    // spacers that previously gave the title, body and footnote different rhythms.
    content: {
      display: "flex",
      flexDirection: "column",
      gap: spacing.m,
      textAlign: "left",
    },
    eyebrow: {
      textTransform: "uppercase",
      letterSpacing: 0.88,
      color: theme.text.secondary,
    },
    subtitle: {
      color: theme.text.secondary,
    },
    note: {
      display: "flex",
      flexDirection: "row",
      gap: spacing.xs,
      padding: spacing.s,
      borderRadius: 10,
      backgroundColor: theme.card.background,
      border: `1px solid ${theme.border}`,
    },
    noteDot: {
      flexShrink: 0,
      width: 6,
      height: 6,
      marginTop: spacing.xs,
      borderRadius: "50%",
      backgroundColor: theme.text.highlight,
    },
    noteText: {
      flex: 1,
    },
    rule: {
      height: 1,
      backgroundColor: theme.border,
    },
    disclaimer: {
      color: theme.text.tertiary,
    },
  };

  return { styles };
};
